import { useEffect, useState } from "react"
import { useSearchParams } from "react-router";
import { getPDF2 } from "../../Fetch/GetPDF";
import { useNavigate } from "react-router"
import Loading from "../../Components/Loading/Loading";
import ObjectPDF from "../../Components/PDF/ObjectPDF";
import './css/pagos.css'
export default function PDFView() {

  const [Comp, setComp] = useState({ Cotizacion: [], Loading: false })
  const [searchParams] = useSearchParams();
  let navigate = useNavigate();

  useEffect(() => {
    document.title = 'KMP-' + searchParams.get("cot");
    getPDF2(searchParams.get("cot"), searchParams.get("hash")).then(res => {
      
      if (res.valid) {
        setComp(v => ({
          ...v,
          Loading: true,
          Cotizacion: res.data.Cot.map((Cdata) => (
            {
              ...v.Cotizacion,
              pdf: 'data:application/pdf;base64,' + Cdata.pdf
            }
          ))
        }))
      } else {
        localStorage.removeItem("ContaKMPCot")
        navigate("/")
      }
    })
  }, [searchParams, navigate])

  return (
    <div className="Pagoview">
      {
        Comp.Loading ?
        Comp.Cotizacion.length > 0 ?
          Comp.Cotizacion.map((C, iC) => (
            <ObjectPDF key={iC} data={C.pdf} toolbar={false}>ObjetoPDF</ObjectPDF>
          )):
          <span>Pdf no encontrado</span>
          :
          <Loading />
      }
    </div>
  )
}